import React from 'react';
import { CheckCircle } from 'lucide-react';
import Button from './Button';
import styles from './StudentWelcome.module.css';

function ProfileCompletion({ completedSteps, navigateToProfile }) {
  if (completedSteps.size < 3) {
    return (
      <section className={`${styles.completionSection} ${styles.incomplete}`}>
        <h2 className={styles.sectionTitle}>Before Applying</h2>
        <p className={styles.sectionDescription}>Complete your profile before starting your application.</p>
        <Button
          className={styles.completeProfileButton}
          onClick={navigateToProfile}
        >
          Complete Profile
        </Button>
      </section>
    );
  }
  
  return (
    <section className={`${styles.completionSection} ${styles.complete}`}>
      <h2 className={`${styles.sectionTitle} ${styles.completeTitle}`}>
        <CheckCircle className={styles.checkIcon} />
        Profile Completed!
      </h2>
      <p className={styles.sectionDescription}>
        Great job! You've completed all the required profile sections. You're now ready to start applying to programs.
      </p>
    </section>
  );
}

export default ProfileCompletion;